import React from "react";
import DynamicLayout from "../components/DynamicLayout";
import SolarReturnExperience from "../components/tools/SolarReturnExperience";
import '../assets/ascendant-display.sass';

const SolarReturnPage = () => {
    return (
        <DynamicLayout>
            <SolarReturnExperience />
        </DynamicLayout>
    );
};

export default SolarReturnPage; 
